export const getParamVal = function(name) {
    const regex = new RegExp(`[?&]${encodeURIComponent(name)}\\=([^&#]+)`);
    const value = (location.search.match(regex) || ['', ''])[1];
    return decodeURIComponent(value);
};

export const handlerCapture = (err, info) => {
    err.message && (err.message = `ZPdelivery:${err.message}`);
    window.Beidou && window.Beidou.captureException(err, info);
    if (window.console && typeof window.console.error === 'function') {
        console.error(err);
    }
};

export const encodeObjectURIComponent = function(obj) {
    // eslint-disable-next-line
    obj = JSON.parse(JSON.stringify(obj));
    for (const key in obj) {
        if (typeof obj[key] === 'object') {
            obj[key] = encodeURIComponent(JSON.stringify(obj[key]));
        } else {
            obj[key] = encodeURIComponent(obj[key]);
        }
    }
    return obj;
};

